import {
  Amount,
  Container,
  Content,
  Price,
  TitleRegistration,
  Total,
  Value,
  Values,
} from "./styles";

const CardRegistration = ({ amount, amountRegistration, clubmed = false }) => {
  const priceOne = clubmed ? "3.200" : "4.400";
  const priceTwo = clubmed ? "2.880" : "3.960";
  const priceThree = clubmed ? "2.592" : "3.564";

  const totalOne = clubmed ? "6.080" : "8.360";
  const totalTwo = clubmed ? "8.672" : "11.924";

  return (
    <Container id="register">
      <Content>
        <Amount>{amount}</Amount>
      </Content>
      <Values>
        {amountRegistration === 1 && (
          <div>
            <TitleRegistration>INSCRIÇÃO ÚNICA</TitleRegistration>
            <Price>R$ {priceOne}</Price>
          </div>
        )}
        {amountRegistration === 2 && (
          <div>
            <TitleRegistration>INSCRIÇÃO 1</TitleRegistration>
            <Price>R$ {priceOne}</Price>
            <TitleRegistration>INSCRIÇÃO 2</TitleRegistration>
            <Price>R$ {priceTwo}</Price>
            <Total>Total</Total>
            <Value>R$ {totalOne}</Value>
          </div>
        )}
        {amountRegistration === 3 && (
          <div>
            <TitleRegistration>INSCRIÇÃO 1</TitleRegistration>
            <Price>R$ {priceOne}</Price>
            <TitleRegistration>INSCRIÇÃO 2</TitleRegistration>
            <Price>R$ {priceTwo}</Price>
            <TitleRegistration>INSCRIÇÃO 3</TitleRegistration>
            <Price>R$ {priceThree}</Price>

            <Total>Total</Total>
            <Value>R$ {totalTwo}</Value>
          </div>
        )}
      </Values>
    </Container>
  );
};

export default CardRegistration;
